var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "videoPlayButton_svg__videoicon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21V3l16 9z",
    fill: "#fff",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJ2aWRlb2ljb24iIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGcgaWQ9IlZpZGVvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTE0MyAtODYwNikiPgogICAgPHBhdGggaWQ9Ikljb24iIGQ9Ik00LDIxVjNsMTYsOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMTE0MyA4NjA2KSIgZmlsbD0iI2ZmZmZmZiIgc3Ryb2tlPSIjZmZmZmZmIiBzdHJva2Utd2lkdGg9IjEiLz4KICAgIDxyZWN0IGlkPSJDb250YWluZXIiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxMTQzIDg2MDYpIiBmaWxsPSJub25lIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgVideoPlayButton as ReactComponent };